export const DASHBOARD_STATUS_EVENT = 'kichat:dashboard-status';
export const LEGACY_API_ERROR_EVENT = 'dashboard-api-error';

export const emitDashboardStatus = (status = {}) => {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(DASHBOARD_STATUS_EVENT, {
      detail: status,
    }),
  );
};
